import React from "react";
import { Row } from "antd";

const Dashboard = ({ children }) => (
  <Row
    type="flex"
    justify="space-around"
    align="top"
    gutter={24}
    style={{
      margin: "13px 13px 0px 0px"
    }}
  >
    {children}
  </Row>
);

export default Dashboard;
